import { fadeIn } from '@/utils/animations/commom';
import { motion } from 'motion/react';
import ConditionalRenderer from '../ConditionalRenderer';
import Text, { TextProps } from '../dataDisplay/Text';
import TextWithCopy from '../dataDisplay/TextWithCopy';
import { ShortEnrollment } from '@/models/Student';

type RowListDisplayProps = {
  items: ShortEnrollment[];
  hasCopyButton?: boolean;
  width?: number;
};

export default function RowListTextDisplay({
  items,
  hasCopyButton = false,
  width,
}: RowListDisplayProps) {
  const defaultTextProps: Pick<TextProps, 'format' | 'className'> = {
    format: 'rubik-400',
    className: 'h-fit truncate',
  };
  const scrollBarClassName =
    'scrollbar-thumb-primary/40 scrollbar-track-primary-content scrollbar-thin scrollbar-track-rounded-ful scrollbar-thumb-rounded-full';
  return (
    <div style={{ width: `${width}%` }} className="pr-2">
      <motion.ul
        className={`flex flex-col w-full gap-2 overflow-y-auto ${scrollBarClassName}`}
        {...fadeIn}
      >
        {items.map(({ name }, index, array) => {
          return (
            <motion.li
              {...fadeIn}
              key={name}
              className="flex flex-col gap-2 px-4"
            >
              <ConditionalRenderer
                condition={hasCopyButton}
                fallback={<Text {...defaultTextProps} text={name} />}
              >
                <TextWithCopy
                  {...defaultTextProps}
                  className={{
                    text: defaultTextProps.className,
                  }}
                  label={name}
                />
              </ConditionalRenderer>

              <ConditionalRenderer condition={index < array.length - 1}>
                <hr className="h-px border-primary/40" />
              </ConditionalRenderer>
            </motion.li>
          );
        })}
      </motion.ul>
    </div>
  );
}
